import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ParamExistsGuard {
  sessionid: string;
  audiostatus: string;
  videostatus: string;
  name: string;

  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Extract and check parameters from the URL
    const url = state.url;
    const paramsExist = this.checkParamsInUrl(url);

    if (paramsExist) {
      return true; // Continue with activating the route
    } else {
      // Redirect to a different route if parameters do not exist
      this.router.navigate([`/joincall/${next.params['id']}`], {
        queryParams: {
          session_id: this.sessionid,
          audioStatus: this.audiostatus,
          videoStatus: this.videostatus,
          name: this.name,
        },
      });
      return false; // Prevent activating the original route
    }
  }

  private checkParamsInUrl(url: string): boolean {
    // Implement logic to check if required parameters exist in the URL
    // You can use URLSearchParams or a custom logic based on your requirements
    // For example:
    const urlSearchParams = new URLSearchParams(url.split('?')[1]);
    this.sessionid = urlSearchParams.get('session_id');
    this.audiostatus = urlSearchParams.get('audioStatus');
    this.videostatus = urlSearchParams.get('videoStatus');
    this.name = urlSearchParams.get('name');
    return (
      urlSearchParams.has('name') &&
      urlSearchParams.has('audioStatus') &&
      urlSearchParams.has('videoStatus')
    );
  }
}
